const pad = (value: number): string => String(value).padStart(2, "0");

// Секунды → «16:14» (время матча) или «0:22» (длина клипа). Одинаково на всех языках.
export const formatClock = (seconds: number): string => {
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(rest)}` : `${minutes}:${pad(rest)}`;
};
